/* ==========================================================================
  main.js
========================================================================== */

"use strict";
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/*function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}*/

let tick = 0;
//const blocks = jQuery(".wp-block-acf-block");
const blocks = jQuery(
    ".slide a, .slide p, .slide h2, .site-footer__billboard__content span"
);
const browserWindow = jQuery(window);
const headerHeight = jQuery(".site-header").height();
const browserWindowHeight = jQuery(window)[0].innerHeight;

blocks.each((index, block) => {
    const elementBlock = jQuery(block);
    if (!elementBlock.hasClass("wp-block-acf-button")) {
        tick++;
        elementBlock.data("animation-tick", tick);
        elementBlock.addClass(
            "animate__animated animate__fadeIn animate__slow"
        );
        browserWindow.scroll(() => {
            if (
                jQuery(window).scrollTop() >=
                    elementBlock.offset().top - browserWindowHeight * (4 / 4) &&
                elementBlock.hasClass("animate__animated")
            ) {
                if (elementBlock.data("animation-tick") % 2 == 0) {
                    elementBlock.removeClass("animate__slideOutDown");
                    elementBlock.addClass("animate__slideInUp show");
                } else {
                    elementBlock.removeClass("animate__slideOutDown");
                    elementBlock.addClass("animate__slideInUp show");
                }
            } else if (
                jQuery(window).scrollTop() <
                    elementBlock.offset().top - browserWindowHeight * (3 / 4) &&
                elementBlock.hasClass("animate__animated")
            ) {
                if (elementBlock.data("animation-tick") % 2 == 0) {
                    elementBlock.removeClass("animate__slideInUp");
                    elementBlock.addClass("animate__slideOutDown");
                } else {
                    elementBlock.removeClass("animate__slideInUp");
                    elementBlock.addClass("animate__slideOutDown");
                }
            }
        });
    }
});

if (jQuery("header").hasClass("landing-page")) {
    browserWindow.scroll((e) => {
        if (browserWindow.scrollTop() > headerHeight) {
            if (!jQuery(".site-header").hasClass("floating")) {
                jQuery(".site-header").removeClass("at-top");
                jQuery(".site-header").addClass("floating");
            }
        } else {
            if (jQuery(".site-header").hasClass("floating")) {
                jQuery(".site-header").removeClass("floating");
                if (!jQuery(".site-header").hasClass("at-top")) {
                    jQuery(".site-header").addClass("at-top");
                }
            }
        }
    });
}

const textLinks = jQuery("#primary p a");
textLinks.each((index, link) => {
    console.log(link);
    jQuery(link).addClass("link link--saana");
});

jQuery(".icon-close-notification").click(() => {
    jQuery("#cookie-notice").hide();
    document.cookie =
        "showConsentNotification=false;expires=Fri, 31 Dec 9999 23:59:59 GMT";
});

const moveLangMenu = () => {
    const mobileWidth = 951;
    if (window.innerWidth > mobileWidth) {
        if (!jQuery("#language-menu").parent().hasClass("header-side-menu")) {
            jQuery("#language-menu").prependTo(".header-side-menu");
        }
    } else if (window.innerWidth <= mobileWidth) {
        if (!jQuery("#language-menu").parent().hasClass("site-header__inner")) {
            jQuery("#language-menu").appendTo(".site-header__inner");
        }
    }
};

/*jQuery(document).ready(() => {
    moveLangMenu();
    if(getCookie('showConsentNotification') != "false") {
           jQuery('#cookie-notice').show();
    }
    window.onresize = () => {
        console.log(window.innerWidth);
        moveLangMenu();
    }
});*/
